import { createFileRoute } from '@tanstack/react-router';
import { useAdminAuthGuard } from '@/features/admin/hooks';
import { SettingsPanel } from '@/features/admin/SettingsPanel';
import { StaffSessionsPanel } from '@/features/admin/StaffSessionsPanel';
import { AdminShell } from '@/features/admin/components/AdminShell';
import { AdminPageHeader } from '@/features/admin/components/AdminPageHeader';
import { AdminLogoutButton } from '@/features/admin/components/AdminLogoutButton';

/**
 * Admin Settings route — runtime operational dials the operator can change
 * without a redeploy: tech-spec extraction on/off and the document upload size
 * limit — with the signed-in staff list (one-click sign-out, for offboarding) above them.
 * Bounces to /admin/login if the admin cookie isn't set.
 */
export const Route = createFileRoute('/admin/settings')({
  component: AdminSettingsPage,
});

function AdminSettingsPage() {
  useAdminAuthGuard();
  return (
    <AdminShell actions={<AdminLogoutButton />}>
      <AdminPageHeader
        title="Settings"
        subtitle="Who's signed in to this console, and the runtime dials. Dial changes apply immediately across the app — no redeploy."
      />
      <div className="flex flex-col gap-8">
        {/* First, not after the ~30 dials: offboarding someone must not need a long scroll. */}
        <StaffSessionsPanel />
        <SettingsPanel />
      </div>
    </AdminShell>
  );
}
